// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"horizontal"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 11H21V21H3z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M3 3H21V7H3V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M3 11H21V21H3V11Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M3 3H21V7H3V3Z","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-horizontal')
export default class HorizontalIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'horizontal',
    }
  }
}
